<template>
    <div ref="contentContainer">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'PageContent',
    mounted() {
        this.processSlotContent();
    },
    methods: {
        processSlotContent() {
            const contentContainer = this.$refs.contentContainer
            // Only run the replace on the transaction details page
            if (contentContainer && this.route().current() === 'admin.accounts.transactions.show') {
                let innerHTML = contentContainer.innerHTML
                // Replace &lbrace;&lbrace; with {{ and &rbrace;&rbrace; with }} in rendered content
                innerHTML = innerHTML
                    .replace(/&amp;lbrace;&amp;lbrace;/g, '&lbrace;&lbrace;')
                    .replace(/&amp;rbrace;&amp;rbrace;/g, '&rbrace;&rbrace;')
                contentContainer.innerHTML = innerHTML
            }
        },
    },
}
</script>

<style scoped>
</style>
